export const NAME = 'Community';

export const SECTIONS = ['informations', 'participants', 'payments', 'groupSend'];
